<template>
    <label :class="classes">
        <input :id="`field-${name}-input`"
               :name="name"
               :aria-labelledby="`field-${name}-label`"
               :checked="value"
               @input="updateValue"
               :placeholder="placeholder"
               class="field-input"
               type="checkbox"
        >
        <span :id="`field-${name}-label`"
              class="field-label"
              aria-hidden="true">
            {{ label }}
        </span>
    </label>
</template>

<script>
  import BaseField from './BaseField';

  export default {
    name: 'CheckboxField',

    extends: BaseField,

    props: {
      label: {
        type:    String,
        default: '',
      },

      labelVisible: {
        type:    Boolean,
        default: false,
      },
    },

    computed: {
      classes () {
        return {
          ...this.baseClasses,
          'field-type-interactive': true,
          'field-type-checkbox':    true,
          'field-with-label':       this.labelVisible,
        };
      },
    },

    methods: {
      updateValue ( event ) {
        this.$emit('input', event.target.checked);
      },
    },
  };
</script>

<!--suppress CssFloatPxLength -->
<style scoped>
    .field-type-checkbox {
        position:        relative;
        display:         flex;
        justify-content: flex-start;
    }

    .field-input {
        height:     0;
        width:      0;
        margin:     0;
        visibility: hidden;
    }

    .field-label {
        cursor:        pointer;
        text-indent:   -9999px;
        width:         2rem;
        height:        1rem;
        background:    var(--color-gray);
        display:       block;
        border-radius: 1rem;
        position:      relative;
    }

    .field.field-with-label .field-label {
        text-indent: 3rem;
        line-height: 1rem;
    }

    .field-label::after {
        content:       '';
        position:      absolute;
        top:           2px;
        left:          1.5px;
        width:         calc(1rem - 4px);
        height:        calc(1rem - 4px);
        background:    var(--color-white-bright);
        border-radius: 1rem;
        transition:    all 125ms;
    }

    .field-input:checked + .field-label {
        background: var(--color-green);
    }

    .field-input:checked + .field-label::after {
        left:      calc(100% - 2px);
        transform: translateX(-100%);
    }

    .field-label:active::after {
    }
</style>
